import { RollingsRelayResponseDto } from '@diritto/common/relay/dtos/rolling-relay.dtos';
import { useInfiniteQuery } from '@tanstack/react-query';
import { RelayRollingApi } from 'api/ApiHelper';
import { relayQueryKey } from 'queries/relay/queryKey';

const DEFAULT_LIMIT = 10;

const getNextPageParam = (lastGroup: RollingsRelayResponseDto, allGroups: RollingsRelayResponseDto[]) => {
  if ((lastGroup.rollings?.length ?? 0) < DEFAULT_LIMIT) {
    return undefined;
  }
  return allGroups.reduce((acc, current) => acc + current.rollings.length, 0);
};

export const useGetProfileRollingsInfiniteQuery = (profileId: number, includeAdult: boolean) =>
  useInfiniteQuery({
    queryKey: relayQueryKey.profileRollings(profileId, includeAdult),
    queryFn: ({ pageParam = 0 }) =>
      RelayRollingApi.findByProfileId(profileId, includeAdult, { offset: pageParam, limit: DEFAULT_LIMIT }),
    initialPageParam: 0,
    getNextPageParam,
  });
